import { render, staticRenderFns } from "./index.vue?vue&type=template&id=35d645f5&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=35d645f5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d645f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d645f5')) {
      api.createRecord('35d645f5', component.options)
    } else {
      api.reload('35d645f5', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=35d645f5&scoped=true", function () {
      api.rerender('35d645f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/TrackCrates/index.vue"
export default component.exports